import React from 'react'
import { Result, Button } from 'antd'
import { logout } from '../../helpers/auth/useSession';

export default function NoCompany() {
    return (
        <Result
            status="403"
            title="No Company Access!"
            subTitle="Sorry, you have not been added to any company. Please ask a company admin to invite you to their company."
            extra={<Button type="primary"
                onClick={async () => {
                    await logout();
                }}
            >Log Out</Button>}
        />
    )
}
